/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ScannerType {
    MOCK_SCANNER = 'MOCK_SCANNER',
    TIGER = 'TIGER',
    I_QUBE_E303 = 'iQUBE_E303',
    UNKNOWN_DEVICE_MODEL = 'UNKNOWN_DEVICE_MODEL',
    INVALID_DEVICE_MODEL = 'INVALID_DEVICE_MODEL',
    OCCIPITAL_ST02A = 'OCCIPITAL_ST02A',
    OCCIPITAL_ST02B = 'OCCIPITAL_ST02B',
    TRUEDEPTH = 'TRUEDEPTH',
}
